<template>
  <div class="news" :class="isCollapse ? 'news-collapse' : ''">
    <div :class="isCollapse ? 'block-collapse' : ''">
      <home-block
        blockIndex="03"
        :blockTitle="$router.lang.get('遊戲資訊')"
        blockTitleEng="DATA"
        :link="links[currentTab]"
      >
        <div :class="!isCollapse ? 'table' : ''">
          <div
            class="news-container"
            :class="
              isCollapse
                ? 'full-collapse'
                : ''
            "
          >
            <div v-if="!isCollapse" class="home-news-tab">
              <pang-tab :tabs="tabs" v-model:current="currentTab" />
              <div class="home-news-more" @click="goto(links[currentTab])">
                +
              </div>
            </div>
            <div>
              <div
                v-for="item in data"
                :key="item.news_type"
                class="news-type-container"
                @click="changeNewsType(item.news_type)"
                :class="
                  currentNewsType == item.news_type ? 'news-type-active' : ''
                "
              >
                <div class="news-type-title">
                  {{ NEWS_TYPES[item.news_type] }}
                </div>
                <i></i>
                <div
                  class="articles"
                  v-if="!isCollapse || currentNewsType == item.news_type"
                >
                  <div
                    class="article-container"
                    :class="subitem.active ? 'active' : ''"
                    @mouseover="activate(subitem)"
                    @mouseleave="deactivate(subitem)"
                    @click="gotoNews(subitem)"
                    v-for="subitem in item.news"
                    :key="subitem.id"
                  >
                    {{ subitem.article.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="maps-container"
            @mouseover="activateMapButt()"
            @mouseleave="deactivateMapButt()"
            :class="
              isCollapse
                ? 'maps-full-collapse'
                :  ''
            "
          >
            <div
              class="map-butt pre-butt"
              @click="preMap"
              :class="mapButt.active || isCollapse ? 'map-butt-active' : ''"
            >
            <div><i class="pre"></i></div>
            </div>
            <div>
              <div v-if="!isCollapse" class="home-news-tab">
                <pang-tab :tabs="tabs2" v-model:current="currentTab" />
                <div class="home-news-more" @click="goto('/news/video')">
                    +
                </div>
              </div>
              <transition name="map">
                <div class="all-maps" :class="isCollapse ? 'all-map-collapse' : ''">
                  <div
                    class="map-item"
                    :class="isCollapse ? 'map-collapse' : ''"
                    v-show="mapShow(i)"
                    @mouseover="activate(map)"
                    @mouseleave="deactivate(map)"
                    @click="showFullMap(i)"
                    :style="{ backgroundImage: 'url(\'' + staticUrl + map.cover + '\')' }"
                    v-for="(map, i) in maps"
                    :key="map.id"
                  >
                    <img v-show="map.active || isCollapse" src="../../../assets/images/play.png"/>
                    <div v-show="map.active || isCollapse" >{{ map.title }}</div>
                  </div>
                </div>
              </transition>
            </div>
            <div
              class="map-butt next-butt"
              @click="nextMap"
              :class="mapButt.active || isCollapse ? 'map-butt-active' : ''"
            >
              <div><i class="next"></i></div>
            </div>
          </div>
        </div>
      </home-block>
      <pang-video-full
        v-if="mapFullShow"
        :videoUrl="maps[currentMapFull].video_url"
        @premap="preMapFull"
        @nextmap="nextMapFull"
        @close="hideMapFull"
      />
    </div>
  </div>
</template>

<script>
import { PangTab, PangVideoFull } from "../../../components";
import enums from "../../../utils/enums.js";
import request from "../../../api/request";
import { useScreenState } from "../../../store";
import HomeBlock from "./HomeBlock";
import message from "../../../utils/message";
import browser from '../../../utils/browser';

export default {
  name: "News",
  components: {
    PangTab,
    HomeBlock,
    PangVideoFull,
  },
    props: {
        maps: {
            type: Array,
            required: true,
        },
    },
  data() {
    return {
      screenState: useScreenState(),
      currentMap: 0,
      mapFullShow: false,
          staticUrl: request.staticUrl,
      tabs: [this.$router.lang.get("遊戲指南")],
      tabs2: [this.$router.lang.get("精選影片")],
      links: [
        "/news",
        "/news/map",
        "/news/guide",
        "/news/guide",
        "/news/guide",
      ],
      mapButt: { active: false },
      data: [
        {
          news_type: 2,
          news: [],
        },
        {
          news_type: 3,
          news: [],
        },
        {
          news_type: 4,
          news: [],
        },
      ],
      NEWS_TYPES: enums.NEWS_TYPES,
      currentTab: 0,
      currentNewsType: 2,
      currentMapFull: 0,
    };
  },
  created() {
    let _this = this;
    function autoplay() {
      if (!_this.paused) _this.nextMap();
      setTimeout(autoplay, 5000);
    }
    setTimeout(autoplay, 5000);
  },
  computed: {
    isCollapse() {
      return this.screenState.screenWidth < 900;
    },
  },
  methods: {
    gotoNews(news) {
      let url = this.links[news.news_type] + "/" + news.id;
      if (browser.isPc)
          window.open(url)
      else
          this.$router.push(url)
    },
    showFullMap(i) {
      this.currentMapFull = i;
      this.mapFullShow = true;
    },
    hideMapFull() {
      this.mapFullShow = false;
    },
    nextMapFull() {
      if (this.currentMapFull < this.maps.length - 1) this.currentMapFull++;
    },
    preMapFull() {
      if (this.currentMapFull > 0) this.currentMapFull--;
    },
    nextMap() {
      if (this.isCollapse)
        this.currentMap = (this.currentMap + 1) % this.maps.length;
      else {
        let currentMap = (parseInt(this.currentMap / 4) + 1) * 4;
        if (currentMap >= this.maps.length) this.currentMap = 0;
        else this.currentMap = currentMap;
      }
    },
    preMap() {
      if (this.isCollapse)
        this.currentMap =
          (this.currentMap + this.maps.length - 1) % this.maps.length;
      else {
        let currentMap = (parseInt(this.currentMap / 4) - 1) * 4;
        if (currentMap < 0)
          this.currentMap = parseInt((this.maps.length - 4) / 4) * 4;
        else this.currentMap = currentMap;
      }
    },
    mapShow(index) {
      if (this.isCollapse) return index == this.currentMap;
      return index >= this.currentMap && index < this.currentMap + 4;
    },
    goto(href) {
      this.$router.push(href);
    },
    activate(news) {
      news.active = true;
    },
    deactivate(news) {
      news.active = false;
    },
    activateMapButt() {
      this.activate(this.mapButt);
      this.paused = true;
    },
    deactivateMapButt() {
      this.deactivate(this.mapButt);
      this.paused = false;
    },
    changeNewsType(news_type) {
      this.currentNewsType = news_type;
    },
    get_api(obj, field, params) {
      let _this = this;
      request.get("/news", params, this).then(function (res) {
        if (res.status == 200) {
          obj[field] = res.data.results;
        } else {
          message.resMessage(res, _this);
        }
      });
    },
    get_data() {
      this.get_api(this.data[0], "news", { news_type: 2, limit: 8 });
      this.get_api(this.data[1], "news", { news_type: 3, limit: 8 });
      this.get_api(this.data[2], "news", { news_type: 4, limit: 8 });
    },
  },
  mounted() {
    this.get_data();
  },
  watch: {},
};
</script>

<style>
.map-enter-active, .map-leave-active {
  transition: opacity 5s;
}
.map-enter, .map-leave-to {
  opacity: 0;
}

.block-collapse .recent-body {
  display: block;
}

.home-news-tab {
  border-bottom: 1px solid #757575;
  display: flex;
}
.home-news-tab > .pang-tab {
  font-size: 1.1vw;
  color: #ffffff;
}

.home-news-tab > .pang-tab > div {
  line-height: 39px;
  padding: 0 2px;
  margin-right: 48px;
}

.home-news-tab > .pang-tab .inactive {
  color: #ffffff;
}

.home-news-tab > .pang-tab .active {
  color: #ffffff;
  border-bottom: 2px solid #c6a86c;
}

.home-news-more {
  margin-left: auto;
  font-size: 20px;
  width: 26px;
  height: 26px;
  border: 1px solid #ffffff;
  border-radius: 50%;
  line-height: 23px;
  text-align: center;
  margin-top: 5px;
  cursor: pointer;
}
</style>

<style scoped>
.news {
  height: calc(900 / 1920 * 100vw);
}

.news > div {
  max-width: calc(72vw + 200px);
  margin: 0 auto;
  width: 80vw;
  padding-top: calc(96 / 1920 * 100vw);
  /* display: flex;
  justify-content: space-around; */
}

@media screen and (max-width: 1366px) {
  .news > div {
    padding-top: calc(60 / 1920 * 100vw);
  }
}

.news-collapse {
  background-color: #10100f;
}

.news-container {
  max-width: 800px;
  width: 34vw;
  background: rgba(41, 38, 38, 0.51);
  padding: 1vw;
  margin: 1vw;
}

.maps-container {
  /* max-width: 450px; */
  /* width: calc(30vw + 80px); */
  background: rgba(41, 38, 38, 0.51);
  padding: 1vw 0;
  margin: 1vw 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.maps-container > div {
  display: inline-block;
}

.maps-container > div:nth-child(2) {
  max-width: 370px;
  width: 30vw;
}

.collapse {
  max-width: none;
  width: calc(90vw - 200px);
}

.maps-collapse {
  max-width: none;
  width: calc(90vw - 120px);
  margin: 19px 0 19px 16px;
}

.maps-collapse > div:nth-child(2) {
  max-width: none;
  width: calc(90vw - 200px);
}

.full-collapse {
  max-width: none;
  width: calc(90vw - 45px);
  margin-left: 0;
  padding: 10px 20px 7px 25px;
  margin-bottom: 0;
}

.maps-full-collapse {
  max-width: none;
  width: calc(90vw - 45px);
  margin: 0;
  padding: 10px 20px 0 25px;
}

.maps-full-collapse > div:nth-child(2) {
  max-width: none;
  width: calc(90vw - 45px);
}

.news-type-container {
  display: flex;
  margin: 26px 0;
}

.articles {
  width: calc(100% - 117px);
  height: 73px;
}

.article-container {
  display: inline-block;
  width: calc(23% - 2px);
  text-align: center;
  line-height: 25px;
  border: 1px solid #434343;
  margin-right: 2%;
  margin-bottom: 13px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.article-container:nth-child(4n) {
  margin-right: 0;
}

.news-type-title {
  width: 44px;
  font-size: 20px;
  color: #ffffff;
  line-height: 31px;
  background-color: #c6a86c;
  padding: 5px 20px;
}

.news-type-container > i {
  margin: auto 2vw auto 0px;
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-left: 8px solid #c6a86c;
  border-bottom: 8px solid transparent;
}

.table {
  display: flex;
  justify-content: space-around;
  /* width: calc(100% - 5.2vw - 1px); */
}

.articles .active {
  color: #c6a86c;
  border: 1px solid #c6a86c;
}

.all-maps {
  min-height: 100%;
  /* width: 34vw; */
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}

.all-maps > div {
  display: flex; 
  flex-basis: calc(50% - 13px);  
  justify-content: center;
  flex-direction: column;
}

.all-map-collapse > div {
  justify-content: inherit;
  flex-basis: inherit;
  width: 83vw;
}

.map-item {
  width: calc(50% - 12px);
  height: 150px;
  margin-top: 1vw;
  background-color: #fff;
  cursor: pointer;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: cover;
}

.map-item > img {
    width: 15%;
    display: inline-block;
    margin: auto;
    padding-top: 10px;
}

.map-item:nth-child(2n + 1) {
  margin-right: 1vw;
}

.map-item > div {
  line-height: 29px;
  padding: 0 10px;
  width: calc(100% - 20px);
  background: rgba(0, 0, 0, 0.48);
  font-size: 14px;
  color: #cacaca;
}

.map-collapse {
  margin: 0;
  width: 90vw;
  height: 50vw;
  background-size: 100% auto;
}

.map-collapse:nth-child(2n + 1) {
  margin-right: 0;
}

.map-collapse > div {
  margin-top: calc(50vw - 29px);
  width: 90vw;
}

.map-butt {
  max-width: 30px;
  max-height: 30px;
  min-width: 20px;
  min-height: 20px;
  width: 2vw;
  height: 2vw;
  margin: 1vw;
  border-radius: 50%;
  /* margin-bottom: 150px; */
}

.map-butt-active {
  background: rgba(0, 0, 0, 0.48);
  cursor: pointer;
  text-align: center;
}

.map-butt-active > div  {
  margin-top: 50%;
}

.map-butt-active > div > i {
  margin-top: -3px;
  margin-left: -3px;
  width: 6px;
  height: 6px;
  border-top: 2px solid #999;
  border-right: 2px solid #999;
  position: absolute;
}

.map-butt-active > div > .pre {
  transform: rotate(-135deg);
}

.map-butt-active > div > .next {
  transform: rotate(45deg);
}

.maps-full-collapse .map-butt-active > div > i {
      margin-top: -5px;
      margin-left: -5px;
      width: 10px;
      height: 10px;
}

.maps-full-collapse > .map-butt {
  position: absolute;
  z-index: 9999;
  max-width: 70px;
  max-height: 70px;
  min-width: 50px;
  min-height: 50px;
  width: 2vw;
  height: 2vw;
  font-size: 2vw;
}

.maps-full-collapse > .map-butt:first-child {
  margin-left: 40px;
}

.maps-full-collapse > .map-butt:last-child {
  margin-right: 40px;
}


.maps-full-collapse > .pre-butt {
  left: 5vw;
}

.maps-full-collapse > .next-butt {
  right: 5vw;
}

.full-collapse .news-type-container .articles {
  position: absolute;
  padding-top: 20px;
  border-top: 1px solid #434343;
  width: 82vw;
}

.full-collapse .news-type-container .article-container {
  font-size: calc(0.56vw + 9px);
}

.full-collapse .news-type-container:nth-child(2) .articles {
  margin-left: calc(15px - 32vw);
}

.full-collapse .news-type-container:nth-child(3) .articles {
  margin-left: calc(30px - 64vw);
}

.full-collapse .news-type-container {
  display: inline-block;
  width: calc(26vw - 15px);
  margin: 0 3vw;
  margin-bottom: 120px;
}

.full-collapse .news-type-container .news-type-title {
  font-size: calc(1vw + 11px);
  width: 100%;
  text-align: center;
  color: #ffffff;
  line-height: 31px;
  background-color: inherit;
  padding: 0;
  cursor: pointer;
  line-height: calc(4vw + 11px);
}

.full-collapse .news-type-container:first-child {
  margin-left: 0;
}

.full-collapse .news-type-container:last-child {
  margin-right: 0;
}

.full-collapse .news-type-container > i {
  margin: 0 auto;
  width: 0;
  height: 0;
  border-left: none;
  border-top: none;
  border-right: none;
  display: block;
}

.full-collapse .news-type-active .news-type-title {
  background-color: #c6a86c;
}

.full-collapse .news-type-active > i {
  margin: 0 auto;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-top: 8px solid #c6a86c;
  border-right: 8px solid transparent;
  display: block;
}

.news-collapse {
  height: calc(60vw + 300px);
}

.news-collapse > div {
  width: 90vw;
}
</style>
